export default __webpack_public_path__ + "media/images/new_year/mosaic_1920x1080-5607a1ff77954a9f767c09c519f0a924.jpg";